const fastSellProductOutboundFormInitialValues = (fastSellProduct) => ({
  outbound_courier     : fastSellProduct?.outbound_courier || '',
  outbound_shipping_no : fastSellProduct?.outbound_shipping_no || ''
})


export default fastSellProductOutboundFormInitialValues
